import React from 'react';
import Lang from '../Lang/Lang';

function PopularBrands(props) {
  const {items} = props;

  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  return (
    <section className="my-10">
      <span className="popular-brands__title flex px-5 pb-3 desktop:px-0 text-[16px] leading-[24px] font-medium text-grey-90 desktop:text-[24px] desktop:leading-[36px]">{Lang.getMessage('Popular brands')}</span>
      <ul
        className="grid gap-2 grid-cols-3 px-5 desktop:grid-cols-6 desktop:gap-5 desktop:px-0">
        {
          items.map((brand, index) => (
            <li
              className="flex items-center justify-center rounded-[12px] bg-[#f5f5f5]"
              key={`popular-brand-${brand.id || index}`}>
              {
                brand.link ? (
                  <a href={brand.link} className="flex items-center justify-center w-full h-full">
                    {
                      brand.image && brand.image.src && (
                        <img
                          src={brand.image.src}
                          loading="lazy"
                          alt={brand.name}
                          className="my-[20px] max-w-[97px] max-h-[38px] w-auto h-auto desktop:max-w-[126px] desktop:max-h-[49px] 500:max-w-[61px] 500:max-h-[24px] phone:my-[10px]"/>
                      )
                    }
                  </a>
                ) : brand.image && brand.image.src && (
                  <img
                    src={brand.image.src}
                    loading="lazy"
                    alt={brand.name}
                    className="my-[20px] max-w-[97px] max-h-[38px] w-auto h-auto desktop:max-w-[126px] desktop:max-h-[49px] 500:max-w-[61px] 500:max-h-[24px] phone:my-[10px]"/>
                )
              }
            </li>
          ))
        }
      </ul>
    </section>
  );
}

export default PopularBrands;
